document.addEventListener("DOMContentLoaded", () => {
    const yearSelect = document.getElementById("year-select");
    const monthSelect = document.getElementById("month-select");

    if (yearSelect) {
        const toggleMonthSelect = () => {
            monthSelect.disabled = !yearSelect.value;
        };

        yearSelect.addEventListener("change", toggleMonthSelect);

        toggleMonthSelect();
    }
});
